export const state = () => ({
  uploadedFiles: [],
  tablesCount: 0,
  reload: false,
  selectedFilesForDelete: [],
  files: [],
  importTabIndex: 0,
  fileNameWarning: false,
  unsupportedFiles: [],
  jobHistoryRecords: {},
  filesInImport: [],
  datasetHistoryFiles: { records: [], count: 0 },
  historyReload: false,
  datasetHistoryFilesRecords: 0
});
